import { useEffect, useState } from "react";
import { XIcon } from "@phosphor-icons/react";
import ReportePublicado from "./ReportePublicado.jsx";
import { numeroContacto } from "./lib/detalleReporte.js";

function partesFecha(fecha) {
  if (!fecha) return { fecha: "", hora: "" };
  const valor = new Date(fecha);
  const fechaLocal = new Intl.DateTimeFormat("en-CA", { timeZone: "America/Bogota", year: "numeric", month: "2-digit", day: "2-digit" }).format(valor);
  const horaLocal = new Intl.DateTimeFormat("en-GB", { timeZone: "America/Bogota", hour: "2-digit", minute: "2-digit", hour12: false }).format(valor);
  return { fecha: fechaLocal, hora: horaLocal };
}

function contactoDesdeReporte(reporte) {
  return {
    nombre: reporte.contacto?.nombre || "Usuario de la comunidad",
    codigoPais: "",
    telefono: numeroContacto(reporte.contacto?.whatsapp),
    email: "",
  };
}

function datosPersona(reporte) {
  const momento = partesFecha(reporte.ultimaVistaEn);
  return {
    nombrePersona: reporte.nombrePersona,
    edadAproximada: reporte.edadAproximada,
    estaturaAproximada: reporte.estaturaAproximada,
    contextura: reporte.contextura,
    coloresCabello: reporte.coloresCabello || [],
    colorCabello: reporte.colorCabello,
    colorOjos: reporte.colorOjos,
    vestimenta: reporte.vestimenta,
    direccionEvento: [reporte.ciudad, reporte.departamento].filter(Boolean).join(", ") || "Ubicación registrada en el mapa",
    fechaEvento: momento.fecha,
    horaEvento: momento.hora,
  };
}

function datosMascota(reporte) {
  const perdida = reporte.tipo !== "ENCONTRADO";
  const momento = partesFecha(perdida ? reporte.perdidoEn : reporte.encontradoEn);
  return {
    nombreMascota: reporte.nombreMascota,
    tipoMascota: reporte.tipoMascota,
    sexo: reporte.sexo,
    tamano: reporte.tamano,
    colorPrincipalPelaje: reporte.colorPrincipalPelaje,
    direccionHallazgo: reporte.direccionHallazgo || "Ubicación registrada en el mapa",
    puntoReferencia: reporte.puntoReferencia,
    ...(perdida
      ? { fechaPerdida: momento.fecha, horaPerdida: momento.hora }
      : { fechaHallazgo: momento.fecha, horaHallazgo: momento.hora }),
  };
}

function varianteFlyer(entidad, tipoReporte) {
  if (entidad === "persona") return "persona";
  if (tipoReporte === "ENCONTRADO") return "encontrada";
  return "perdida";
}

function cargarDimensiones(url) {
  return new Promise((resolver) => {
    const imagen = new Image();
    imagen.onload = () => resolver({ ancho: imagen.naturalWidth, alto: imagen.naturalHeight });
    imagen.onerror = () => resolver({ ancho: 0, alto: 0 });
    imagen.src = url;
  });
}

export default function HistoriaDesdePerfil({ entidad, reporte, onClose }) {
  const [fotos, setFotos] = useState([]);
  const [fotosPreparadas, setFotosPreparadas] = useState(false);

  useEffect(() => {
    let vigente = true;
    const base = entidad === "persona" ? "personas" : "mascotas";
    const candidatas = (reporte.multimedia || [])
      .filter((medio) => medio.tipo === "FOTO")
      .map((medio) => ({ id: medio.id, url: `/api/${base}/${reporte.id}/multimedia/${medio.id}/archivo` }));
    setFotosPreparadas(false);
    Promise.all(candidatas.map(async (foto) => ({ ...foto, ...await cargarDimensiones(foto.url) })))
      .then((resultado) => { if (vigente) { setFotos(resultado); setFotosPreparadas(true); } });
    return () => { vigente = false; };
  }, [entidad, reporte]);

  useEffect(() => {
    function cerrarConEscape(evento) {
      if (evento.key === "Escape") onClose();
    }
    document.addEventListener("keydown", cerrarConEscape);
    document.body.classList.add("modal-open");
    document.body.classList.add("story-modal-open");
    return () => {
      document.removeEventListener("keydown", cerrarConEscape);
      document.body.classList.remove("modal-open");
      document.body.classList.remove("story-modal-open");
    };
  }, [onClose]);

  const persona = entidad === "persona";
  const variante = varianteFlyer(entidad, reporte.tipo);
  const datos = persona ? datosPersona(reporte) : datosMascota(reporte);

  let contenido = <div className="story-modal__loading"><span className="loader" /><p>Preparando las fotos para la historia…</p></div>;
  if (fotosPreparadas && fotos.length === 0) contenido = <div className="story-modal__loading"><p>Este reporte no tiene una fotografía disponible para generar la historia.</p></div>;
  if (fotos.length > 0) contenido = <ReportePublicado soloFlyer variante={variante} resultado={{ codigoGestion: "", multimedia: [] }} datos={datos} fotos={fotos} contacto={contactoDesdeReporte(reporte)} onInicio={onClose} textoBotonInicio="Cerrar imagen" />;

  return <div className="story-modal" role="dialog" aria-modal="true" aria-label="Imagen para compartir en historias"><div className="story-modal__panel"><button className="story-modal__close" type="button" onClick={onClose} aria-label="Cerrar"><XIcon weight="bold" /></button>{contenido}</div></div>;
}
